/**
 * 房源管理路由
 */
export default {
  path: '/lock',
  name: 'lock',
  redirect: '/lock/lockManage',
  component: () => import('../views/lock/index.vue'),
  meta: {
    headerTitle: '门锁',
    icon: 'ab-iconfont ab-icon-lock',
    auth: 1003
  },
  children: [
    {
      path: 'lockManage',
      name: 'lockManage',
      redirect: '/lock/lockManage/lockList',
      component: () => import('../views/lock/lockManage/index.vue'),
      meta: {
        headerTitle: '门锁管理',
        icon: 'lock-line',
        noShowMenu: true
      },
      children: [
        {
          path: 'lockList',
          name: 'lockList',
          component: () => import('../views/lock/lockManage/list.vue'),
          meta: {
            headerTitle: '门锁管理'
          }
        },
        {
          path: 'setAllPermission',
          name: 'setAllPermission',
          component: () => import('../views/lock/lockManage/setAllPermission.vue'),
          meta: {
            headerTitle: '批量设置门锁密码',
            hasBreadcrumb: true,
            isDetailPage: true
          }
        },
        {
          path: 'setPermissionList',
          name: 'setPermissionList',
          component: () => import('../views/lock/lockManage/setPermissionList.vue'),
          meta: {
            headerTitle: '管理门锁密码',
            hasBreadcrumb: true,
            isDetailPage: true
          }
        }
      ]
    },
    {
      path: 'openDoorRecords',
      name: 'openDoorRecords',
      component: () => import('../views/lock/openDoorRecord/index.vue'),
      meta: {
        headerTitle: '开门记录',
        icon: 'person-check'
      }
    },
    {
      path: 'lockOrder',
      name: 'lockOrder',
      redirect: '/lock/lockOrder/lockOrderList',
      component: () => import('../views/lock/lockOrder/index.vue'),
      meta: {
        headerTitle: '门锁订单',
        icon: 'order',
        noShowMenu: true
      },
      children: [
        {
          path: 'lockOrderList',
          name: 'lockOrderList',
          component: () => import('../views/lock/lockOrder/list.vue'),
          meta: {
            headerTitle: '门锁订单'
          }
        },
        {
          path: 'lockOrderDetail',
          name: 'lockOrderDetail',
          component: () => import('../views/lock/lockOrder/detail.vue'),
          meta: {
            headerTitle: '订单详情',
            hasBreadcrumb: true,
            fixedBreadcrumb: true,
            isDetailPage: true
          }
        },
        {
          path: 'lockOrderCreate',
          name: 'lockOrderCreate',
          component: () => import('../views/lock/lockOrder/create.vue'),
          meta: {
            headerTitle: '填写预约信息',
            hasBreadcrumb: true,
            isDetailPage: true
          }
        },
        {
          path: 'lockOrderPay',
          name: 'lockOrderPay',
          component: () => import('../views/lock/lockOrder/pay.vue'),
          meta: {
            headerTitle: '付款',
            hasBreadcrumb: true,
            isDetailPage: true
          }
        }
      ]
    },
    {
      path: 'locklog',
      name: 'locklog',
      component: () => import('../views/lock/locklog/index.vue'),
      meta: {
        headerTitle: '解绑/绑定日志',
        icon: 'log'
      }
    },
  ]
}
